<template>
  <button>
    <a :href="mmUrl" @click.prevent="getMareiMekomos()">
      <i class="fa fa-fw fa-paperclip"></i>
    </a>
  </button>
</template>
<script>
export default {
  props: ['shiurim', 'magidShiur'],
  data: function () {
    return {
      loading: false,
      error: false,
      mareiMekomos: null,
    };
  },
  computed: {
    mmUrl() {
      if (this.$store.state.auth.token && this.shiurim.notefile) {
        return this.shiurim.notefile.url;
      }
      return '#';
    },
  },
  methods: {
    getMareiMekomos: function () {
      var self = this;
      this.error = this.mareiMekomos = null;
      this.loading = true;
      this.$http.get('/api/shiur/' + this.shiurim.id + '/mm').then(function (response) {
        if (response.data.note) {
          var data = {
            masechta: response.data.masechta,
            shiurim: self.shiurim,
            magidShiur: self.magidShiur,
            note: response.data.note,
          };
          self.$root.$emit('show_mm_modal', data);
          self.$root.$emit('bv::show::modal', 'marei-mekomos');
        } else {
          const url = response.data.file || response.data.filename;
          const downloadFilename = response.data.download_filename || null;

          // self.downloadFileUsingURL(url, downloadFilename);
          self.downloadFileUsingAnchorTag(response);
        }
      });
    },
    downloadFileUsingAnchorTag(response) {
      const url = response.data.file;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('id', 'tmpdonwload');
      link.setAttribute('target', '_blank');
      link.setAttribute('download', response.data.download_filename);
      document.body.appendChild(link);
      console.log(link);
      link.click();
      // document.body.removeChild(link);
    },
  },
};
</script>
